import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LoginRoute extends Route {
  @service session;

  beforeModel() {
    return this.session.prohibitAuthentication('index');
  }
}
